import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import ResponseLoadingOverlay_vue_vue_type_script_setup_true_lang_default from "./ResponseLoadingOverlay.vue.script.js";
/* empty css                                     */
//#region src/v2/blocks/response-block/components/ResponseLoadingOverlay.vue
var ResponseLoadingOverlay_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ResponseLoadingOverlay_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-28d73262"]]);
//#endregion
export { ResponseLoadingOverlay_default as default };

//# sourceMappingURL=ResponseLoadingOverlay.vue.js.map